<div class="loader">
  @for (delay of animationDelays(); track delay) {
    <!-- <span [style.animation-delay]="dot" ></span> -->
    <span [ngStyle]="{ 'animation-delay': delay, width: height() + 'rem', height: height() + 'rem' }"></span>
  }
</div>
